// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"83":"dd687e7873531f03","821":"0f67b3ba3be17e89"}[chunkId] + ".js";
};